export default __webpack_public_path__ + "images/Capa_1-2.d7d0986219c7b2b4d2c5b18fc2d3c683.png";